export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-colmo-tag/index.js